/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownBetweenLines: {
  name: 'arrow-down-between-lines';
  data: string;
} = {
  name: 'arrow-down-between-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 1a.5.5 0 0 0-1 0v14a.5.5 0 0 0 1 0V1ZM8 .5a.5.5 0 0 1 .5.5v12.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 13.793V1A.5.5 0 0 1 8 .5Zm4 0a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>`,
};
